import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : u.role === "host" ? "/host" : "/");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-14">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="login-title">Sign in</h1>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
        <input type="email" required placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} className="w-full border border-slate-200 rounded-lg p-3 text-sm" data-testid="login-email"/>
        <input type="password" required placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-slate-200 rounded-lg p-3 text-sm" data-testid="login-password"/>
        {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
        <button disabled={loading} className="btn-amber w-full rounded-full py-3 text-sm" data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="text-sm text-slate-600 mt-6">No account? <Link to="/register" className="font-semibold text-[var(--fpn-navy)] underline" data-testid="login-register-link">Create one</Link></p>
    </div>
  );
}
